import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  FAQ: string;
  KB: string;
  wpAutoLoginUrl: string;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {
    this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('outer-page');
    // window.scroll(0, 0);
  }

  ngOnInit() {
    this.wpAutoLoginUrl = environment.WP_AUTO_LOGIN_URL;
    this.FAQ = environment.FAQ;
    this.KB = environment.KB;
  }

  getToken() {
    let token = null;
    let userData = null;
    userData = JSON.parse(window.localStorage.getItem('userDetails'))
    if (userData) {
      token = userData.accessToken;
    } else {
      userData = JSON.parse(window.sessionStorage.getItem('userDetails'));
      token = userData != null ? userData.accessToken : null;
    }
    return token;
  }

  navRouteToFAQ() {
    const token = this.getToken();
    if (token) {
      const eventUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=faq`;
      window.open(eventUrl, '_self');
    } else {
      window.open(this.FAQ, '_self');
    }
  }

  navRouteToKB() {
    const token = this.getToken();
    if (token) {
      const eventUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=knowledge_base`;
      window.open(eventUrl, '_self');
    } else {
      window.open(this.KB, '_self');
    }
  }

  navContactUs() {
    this.router.navigate(['/contact-us'])
  }

  featureUnderConstructionNavigation() {
      this.router.navigate([`under-construction`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/support/support.component.ts